export interface Order {
  id: number,
  patientFullname: string,
  product: string,
  institution: string,
  email: string,
  phone: string,
  date: string,
  state: string
}